/**
 * Bookings icon: calendar with checkmark.
 * Uses the provided booking icon image.
 */
export default function BookingsIcon({ size = 20, style = {} }) {
  return (
    <img
      src="/icons/bookings-icon.png"
      alt=""
      width={size}
      height={size}
      style={{ display: 'block', flexShrink: 0, objectFit: 'contain', imageRendering: '-webkit-optimize-contrast', ...style }}
    />
  );
}
